import { Inject, DOMUtils, Container, Api } from '@atypon/ui-utils';

class Recaptcha {

    @Inject()
    domUtils: DOMUtils;

    wrapper: HTMLElement;


    get grecaptcha() { return window['grecaptcha']; };


    initialize(wrapper: HTMLElement = document.body) {
        this.wrapper = wrapper;
        if (typeof this.grecaptcha == 'undefined') {
            return;
        }
        window['loadRecaptcha'] = this.onLoaded.bind(this);
    }

    onLoaded() {
        if (typeof this.grecaptcha == 'undefined') return;
        const recapthca = this.domUtils.getElements('.g-recaptcha:not(.explicit)', this.wrapper);
        recapthca.forEach(element => {
            this.grecaptcha.render(element, element.dataset);
            this.domUtils.getElement('iframe').setAttribute('title', 'reCaptcha');
        })
    }

    clearCapcha() {
        if (typeof this.grecaptcha != 'undefined') {
            this.grecaptcha.reset(0);
        }
    }

    captchaChallengeSubmit = (response) => {
        const elm = this.domUtils.getElement<HTMLInputElement>('textarea#g-recaptcha-response');
        if (elm && elm == response) {
            this.domUtils.closest<HTMLFormElement>('form', elm)?.submit();
        }
        window['captchaChallengeSubmit'] = this.captchaChallengeSubmit;
    }

    static async loadAjaxCaptcha(wrapper: HTMLElement, domUtils: DOMUtils) {
        const api = Container.get(Api);
        const newWrapper = wrapper;
        try {
            const text = await api.renderWidget<string>(null, 'CaptchaResponseHandler/');
            if (text.length) {
                newWrapper.innerHTML = text;
                domUtils.replaceElement(wrapper, newWrapper);
            }
        } catch (error) {

        }
    }

}


export default Recaptcha;
